import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { config } from "../CommonUrl/CommonUrls";
import { TokenAlert } from "../CommonPopupAndAlerts/SweetAlerts";
const RefreshFunction = async (url, values, method) => {
  var refreshToken = Cookies.get("refreshToken")
  var initvalues = {
    refreshToken: refreshToken
  }
  try {
    let ref_url = config.url.DSC_URL + "auth/refresh-token"
    const res = await axios.post(ref_url, initvalues);
    if (res.data.scode === "01") {
      var decoded = jwtDecode(res.data.access_token);
      var decoded_refresh = jwtDecode(res.data.refresh_token);
      var date = new Date(decoded.exp * 1000);
      var ref_date = new Date(decoded_refresh.exp * 1000);
      Cookies.set("token", res.data.access_token, { expires: date });
      Cookies.set("refreshToken", res.data.refresh_token, { expires: ref_date });
      if (method === "get") {
        return CommonAxiosGet(url);
      }
      else if (method === "post") {
        return CommonAxiosPost(url, values);
      }
    }
  } catch (err) {
    console.log("error at refresh token>>>>>", err)
  }
}
// export const CommonAxiosGet = async (url, values) => {
//   // let dsc_url = config.url.DSC_Read_URL
//   // url = dsc_url + url.split('apdscapi')[1]
//   url = url.split('apdscapi')[0] + 'apdscreadapi' + url.split('apdscapi')[1]
//   let token = Cookies.get("token");
//   let refreshToken = Cookies.get("refreshToken");
//   if (token === undefined && refreshToken !== undefined) {
//     return RefreshFunction(url, values, "get")
//   }
//   else if (token !== undefined) {
//     let data = "";
//     try {
//       let res = await axios({
//         url: url,
//         method: "get",
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       if (res.status === 200) {
//         data = res;
//       }
//       return data;
//     } catch (err) {
//       console.log("error at commonget>>>>", err)
//     }
//   }
//   else if (refreshToken === undefined) {
//     TokenAlert()
//   }

// }
export const CommonAxiosGet = async (url, values) => {
  // Only replace 'apdscapi' if 'apdscdeptapi' is not present
  if (url.includes('apdscapi') && !url.includes('apdscdeptapi')) {
    url = url.replace('apdscapi', 'apdscreadapi');
  }

  const token = Cookies.get("token");
  const refreshToken = Cookies.get("refreshToken");

  if (!token && refreshToken) {
    return RefreshFunction(url, values, "get");
  } else if (token) {
    try {
      const res = await axios({
        url: url,
        method: "get",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.status === 200) {
        return res;
      }
    } catch (err) {
      console.log("error at commonget >>>>", err);
    }
  } else if (!refreshToken) {
    TokenAlert();
  }
};
export const CommonAxiosGetNotRead = async (url, values) => {
  const token = Cookies.get("token");
  const refreshToken = Cookies.get("refreshToken");

  if (!token && refreshToken) {
    return RefreshFunction(url, values, "get");
  } else if (token) {
    try {
      const res = await axios({
        url: url,
        method: "get",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.status === 200) {
        return res;
      }
    } catch (err) {
      console.log("error at commonget >>>>", err);
    }
  } else if (!refreshToken) {
    TokenAlert();
  }
};
export const CommonAxiosPost = async (url, values) => {
  let data = "";
  let token = Cookies.get("token");
  let refreshToken = Cookies.get("refreshToken");
  if (token === undefined && refreshToken !== undefined) {
    return RefreshFunction(url, values, "post")
  }
  else if (token !== undefined) {
    try {
      let res = await axios({
        url: url,
        method: "post",
        data: values,
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.status === 200) {
        data = res;
      }
      return data;
    } catch (err) {
      console.log("error at commonget>>>>", err)
    }
  }
  else if (refreshToken === undefined) {
    TokenAlert()
  }
};
export const CommomLoginAunthenticatePost = async (url, values) => {

  try {
    let data = "";
    let res = await axios({
      url: url,
      method: "post",
      data: values,
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) { }
};
export const CommonAxiosPut = async (url, values) => {
  let token = Cookies.get("token");
  try {
    let data = "";
    let res = await axios({
      url: url,
      method: "put",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) { }
};
